import { ConnectionStatus } from '@shared/models/constants/ConnectionStatus.enum';
import { NetworkService } from '@shared/providers/network.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { UtilsService } from '@shared/providers/utils.service';
import { File } from '@ionic-native/file/ngx';

import { WitnessSignatureService } from './witness-signature.service';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.page.html',
  styleUrls: ['./signature.page.scss'],
})
export class SignaturePage implements OnInit {
  public isHomeSignagure = true;
  public witnessSignatureData: any;
  private id: string;
  public displayOriginalSize = false;
  public reportLink: string;
  public retry = false;

  constructor(
    private witnessSignatureService: WitnessSignatureService,
    private activatedAroute: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private platform: Platform,
    private networkService: NetworkService,
    private translate: TranslateService,
    private file: File,
    private httpClient: HttpClient,
    private socialSharing: SocialSharing  ) {}

  async ngOnInit() {
    this.id = this.activatedAroute.snapshot.paramMap.get('id');
    if (this.platform.is('mobile')) {
      this.displayOriginalSize = true;
    }
  }

  async ionViewWillEnter() {
    await this.updateElements();
  }
  async updateElements() {
    try {
      this.retry = false;
      await this.utils.presentLoading(`${this.translate.instant('SIGNATURE.PREPARING_REPORT')}`);
      this.witnessSignatureData = await this.witnessSignatureService.getWitnessSignatureData(this.id);
      this.reportLink = this.witnessSignatureData.witnessSignature.surveyReportLink;
    } catch (error) {
      this.retry = true;
      console.error(error);
      this.router.navigateByUrl(`testemunha/assinar/erro`);
      this.utils.showToast('', `${this.translate.instant('SIGNATURE.SIGNATURE_REQUEST')}`);
    } finally {
      this.utils.dismissLoading();
    }
  }

  goToAssign() {
    this.router.navigateByUrl(`testemunha/assinar/${this.id}`);
  }

  onError(error: any) {
    console.error(error);
    let message = '';
    if (this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Offline) {
      message = `${this.translate.instant('SIGNATURE.UNABLE_TO_DOWNLOAD')}`;
    } else {
      message = `${this.translate.instant('SIGNATURE.UNABLE_TO_DOWNLOAD_THIS')}`;
    }
    this.utils.showToast('', message);
    this.router.navigateByUrl(`testemunha/assinar/erro`);
  }

  async share(url, isPending, event) {
    if (isPending) {
      return;
    }

    if (event) {
      event.stopPropagation();
    }

    try {
      await this.platform.ready();
      if (this.platform.is('cordova')) {
        await this.download(url);
        const file = await this.resolvelocalFile();
        await this.socialSharing.share(
          `${this.translate.instant('SURVEYS.DETAILS.REPORT_SHARING')}`,
          '',
          file.nativeURL
        );
        this.removeTempFile(file.name);
      } else {
        this.downloadReport(url);
      }
    } catch (error) {
      console.error(error);
      this.utils.showToast('', `${this.translate.instant('SURVEYS.DETAILS.ERROR_SHARING_REPORT')}`);
    }
  }

  removeTempFile(name) {
    this.file.removeFile(this.file.cacheDirectory, name);
  }

  downloadReport(url) {
    window.open(url, '_blank');
  }

  async download(url) {
    const file = await this.httpClient.get(url, { responseType: 'blob' }).pipe().toPromise();

    return this.file.writeFile(this.file.dataDirectory, 'my_dowloaded_file.pdf', file, { replace: true });
  }

  resolvelocalFile() {
    return this.file.copyFile(
      `${this.file.dataDirectory}`,
      `my_dowloaded_file.pdf`,
      this.file.cacheDirectory,
      `${new Date().getTime()}.pdf`
    );
  }
}
